var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossAroww(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 0.970703C5.31375 0.970703 0.84375 5.4407 0.84375 10.9707C0.84375 16.5007 5.31375 20.9707 10.8438 20.9707C16.3738 20.9707 20.8438 16.5007 20.8438 10.9707C20.8438 5.4407 16.3738 0.970703 10.8438 0.970703ZM15.8438 14.5607L14.4338 15.9707L10.8438 12.3807L7.25375 15.9707L5.84375 14.5607L9.43375 10.9707L5.84375 7.3807L7.25375 5.9707L10.8438 9.5607L14.4338 5.9707L15.8438 7.3807L12.2537 10.9707L15.8438 14.5607Z",
    fill: "#421F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossAroww);
export default __webpack_public_path__ + "static/media/CrossAroww.ca5ac46fd3fd27ec2cfa5d0803a99995.svg";
export { ForwardRef as ReactComponent };